<script setup lang="ts">
import type { SelectItemProps } from "./select.types";
import { useSelectItem } from "./useSelect.Item";

// Note: SelectItem wraps ListboxItem, which serves as the shared base component
// for collection items. This avoids duplication between Select and Listbox.
defineOptions({ name: "ESelectItem" });

const props = withDefaults(defineProps<SelectItemProps>(), {
  disabled: false,
  selectedIcon: "check",
  showSelectedIcon: true,
  label: undefined,
  color: undefined,
  variant: undefined,
  size: undefined,
  icon: undefined,
  leading: undefined,
  leadingIcon: undefined,
  trailing: undefined,
  trailingIcon: undefined,
  loading: undefined,
  loadingIcon: undefined,
});

const { isHighlighted, isSelected, isDisabled, itemStyle, color, variant, size, handleSelect } = useSelectItem({
  props,
});
</script>

<template>
  <e-listbox-item
    class="e-select-item"
    :style="itemStyle"
    :value="value"
    :label="label"
    :disabled="isDisabled"
    :selected="isSelected"
    :color="color"
    :variant="variant"
    :size="size"
    :highlighted="isHighlighted"
    :selected-icon="selectedIcon ?? 'check'"
    :show-selected-icon="showSelectedIcon ?? true"
    :icon="icon"
    :leading="leading"
    :leading-icon="leadingIcon"
    :trailing="trailing"
    :trailing-icon="trailingIcon"
    :loading="loading"
    :loading-icon="loadingIcon"
    @select="handleSelect"
  >
    <slot slot="leading" name="leading" />
    <slot />
    <slot slot="trailing" name="trailing" />
  </e-listbox-item>
</template>

<style>
:host {
  display: contents;
}
</style>
